import React from 'react'
import * as d3 from "../d3.modified.js"

export default class Indicators extends React.Component {
    render() {
        let hasComments = (this.props._c>0)
        let hasFiles = (this.props._f>0)
        let hasLinks = (this.props._l>0)

        if (!hasComments && !hasFiles && !hasLinks) {
            return null
        }

        let width = (hasComments?20:0)+(hasFiles?20:0)+(hasLinks?20:0)
        let height = 22

        if (this.props.vertical) {
            let t = width
            width = height
            height = t
        }

        return (
            <foreignObject ref={c=>this.indicatorHolder=c} x={this.props.x-width*0.5} y={this.props.y-height*.5-(this.props.vertical?1:0)} width={width+(this.props.vertical?0:2)} height={height+(this.props.vertical?2:0)}>
                <div xmlns="http://www.w3.org/1999/xhtml" className="node-indicator">
                    {
                        (!hasFiles)
                            ? null
                            : (
                                <span title={`${this.props._f} attachment(s)`} className={this.props.vertical?'vertical':''}>
                                    <svg width="16" height="16" viewBox="0 0 20 20">
                                        <path fill="#aaa" d="M9.5 20c-2.481 0-4.5-2.019-4.5-4.5v-12c0-1.93 1.57-3.5 3.5-3.5s3.5 1.57 3.5 3.5v11c0 1.378-1.122 2.5-2.5 2.5s-2.5-1.122-2.5-2.5v-6c0-0.276 0.224-0.5 0.5-0.5s0.5 0.224 0.5 0.5v6c0 0.827 0.673 1.5 1.5 1.5s1.5-0.673 1.5-1.5v-11c0-1.378-1.122-2.5-2.5-2.5s-2.5 1.122-2.5 2.5v12c0 1.93 1.57 3.5 3.5 3.5s3.5-1.57 3.5-3.5v-7c0-0.276 0.224-0.5 0.5-0.5s0.5 0.224 0.5 0.5v7c0 2.481-2.019 4.5-4.5 4.5z" />
                                    </svg> {/*this.props._f*/}
                                </span>
                            )
                    }
                    {
                        (!hasLinks)
                            ? null
                            : (
                                <span title={`${this.props._l} URLs`} className={this.props.vertical?'vertical':''}>
                                    <svg width="16" height="16" viewBox="0 0 20 20">
                                        <path fill="#aaa" d="M10.682 12.998c-0.943 0-1.886-0.359-2.604-1.077-0.195-0.195-0.195-0.512 0-0.707s0.512-0.195 0.707 0c1.046 1.046 2.747 1.046 3.793 0l3.636-3.636c1.046-1.046 1.046-2.747 0-3.793s-2.747-1.046-3.793 0l-3.068 3.068c-0.195 0.195-0.512 0.195-0.707 0s-0.195-0.512 0-0.707l3.068-3.068c1.436-1.436 3.772-1.436 5.207 0s1.436 3.772 0 5.207l-3.636 3.636c-0.718 0.718-1.661 1.077-2.604 1.077z"></path>
                                        <path fill="#aaa" d="M4.682 18.998c-0.943 0-1.886-0.359-2.604-1.077-1.436-1.436-1.436-3.772 0-5.207l3.636-3.636c1.436-1.436 3.772-1.436 5.207 0 0.195 0.195 0.195 0.512 0 0.707s-0.512 0.195-0.707 0c-1.046-1.046-2.747-1.046-3.793 0l-3.636 3.636c-1.046 1.046-1.046 2.747 0 3.793s2.747 1.046 3.793 0l3.068-3.068c0.195-0.195 0.512-0.195 0.707 0s0.195 0.512 0 0.707l-3.068 3.068c-0.718 0.718-1.661 1.077-2.604 1.077z"></path>
                                    </svg> {/*this.props._l*/}
                                </span>
                            )
                    }
                    {
                        (!hasComments)
                            ? null
                            : (
                                <span title={`${this.props._c} comments`} className={this.props.vertical?'vertical':''}>
                                    <svg width="16" height="16" viewBox="0 0 20 20">
                                        <path fill="#aaa" d="M0.5 19c-0.225 0-0.422-0.15-0.482-0.367s0.032-0.447 0.225-0.562c1.691-1.014 2.392-2.489 2.641-3.179-1.838-1.407-2.884-3.354-2.884-5.392 0-1.029 0.258-2.026 0.768-2.964 0.486-0.894 1.18-1.695 2.061-2.381 1.787-1.39 4.156-2.156 6.671-2.156s4.884 0.766 6.671 2.156c0.881 0.685 1.575 1.486 2.061 2.381 0.51 0.937 0.768 1.934 0.768 2.964s-0.258 2.026-0.768 2.964c-0.486 0.894-1.18 1.695-2.061 2.381-1.787 1.39-4.156 2.156-6.671 2.156-1.033 0-2.047-0.129-3.016-0.385-0.429 0.286-1.231 0.793-2.189 1.27-1.488 0.74-2.764 1.115-3.794 1.115zM9.5 3c-4.687 0-8.5 2.916-8.5 6.5 0 1.815 1.005 3.562 2.756 4.792 0.172 0.121 0.25 0.336 0.196 0.539-0.117 0.436-0.515 1.633-1.58 2.788 1.302-0.456 2.704-1.247 3.739-1.959 0.123-0.085 0.277-0.11 0.421-0.069 0.948 0.271 1.947 0.409 2.968 0.409 4.687 0 8.5-2.916 8.5-6.5s-3.813-6.5-8.5-6.5z"/>
                                    </svg> {/*this.props._c*/}
                                </span>
                            )
                    }
                </div>
            </foreignObject>
        )
    }
}


// WEBPACK FOOTER //
// ./src/components/nodes/Indicators.js